<div class="wrapper">
  <header>
    <reza-header />
    <reza-navbar />
  </header>
  @if (!hideBreadcrumb) { @if (breadcrumbs$ | async; as breadcrumbs) {
  <page-settings-breadcrumbs [breadcrumbs]="breadcrumbs" />
  } }
  <main>
    <ui-wrapper>
      <ui-router-outlet />
    </ui-wrapper>
  </main>
  <footer>
    <reza-footer [publicFooter]="true" />
  </footer>
</div>
